import React from "react";
import PropTypes from "prop-types";
import TextField from "../../../common/TextField";

const renderTextField = ({
  label,
  input,
  meta: {touched, invalid, error},
  ...custom
}) => (
  <TextField
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    fullWidth
    {...input}
    {...custom}
  />
);

renderTextField.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default renderTextField;
